import React from 'react';
import classNames from 'classnames';
import Spinner from './components/Spinner';
import getSuitableImageSize from './utils/getSuitableImageSize';
import useMountedState from './utils/useMountedState';
import './Photo.less';
import { brokenElementDataType } from './types';

export interface IPhotoProps extends React.HTMLAttributes<any> {
  src: string;
  intro?: React.ReactNode;
  loaded: boolean;
  broken: boolean;
  width: number;
  height: number;
  rotate: number;
  className?: string;
  onImageLoad: (PhotoParams, callback?: Function) => void;
  loadingElement?: JSX.Element;
  brokenElement?: JSX.Element | ((photoProps: brokenElementDataType) => JSX.Element);
}

const CustomVideo: React.FC<IPhotoProps> = props => {
  const {
    src,
    intro,
    loaded,
    broken,
    width,
    height,
    rotate,
    className,
    onImageLoad,
    loadingElement,
    brokenElement,
    ...restProps
  } = props;

  const isMounted = useMountedState();

  function handleImageLoaded(e) {
    const { naturalWidth, naturalHeight } = e.target;
    if (isMounted()) {
      onImageLoad({
        loaded: true,
        naturalWidth,
        naturalHeight,
        ...getSuitableImageSize(naturalWidth, naturalHeight, rotate),
      });
    }
  }

  function handleImageBroken() {
    if (isMounted()) {
      onImageLoad({
        broken: true,
      });
    }
  }

  React.useEffect(() => {
    const video = document.createElement('video');
    video.src = src;
    video.onerror = handleImageBroken;
    video.onloadeddata = () => {
      handleImageLoaded({ target: { naturalHeight: video.videoHeight, naturalWidth: video.videoWidth } });
    };
  }, []);

  if (src && !broken) {
    if (loaded) {
      return (
        <video
          onMouseUp={e => e.stopPropagation()}
          onMouseMove={e => e.stopPropagation()}
          onMouseOver={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
          src={src}
          controls
          // @ts-ignore
          controlslist="nodownload noremoteplayback"
          disablePictureInPicture
          className={classNames('PhotoView__Photo', className)}
          width={width}
          height={height}
          {...restProps}
        />
      );
    }
    return loadingElement || <Spinner />;
  }
  if (brokenElement) {
    if (typeof brokenElement === 'function') {
      return brokenElement({
        src,
        intro,
      });
    }
    return brokenElement;
  }
  return null;
};

CustomVideo.displayName = 'Photo';

export default CustomVideo;
